import apiService from './api-service';

const FUEL_CONSUMPTION_SENSOR_VERIFICATION = 1;
const FUEL_LEVEL_SENSOR_VERIFICATION = 2;
const MAX_FUEL_HEIGHT = 3;
const MIN_FUEL_HEIGHT = 4;
const MAX_WATER_HEIGHT = 5;
const MIN_WATER_HEIGHT = 6;
const FUEL_LEVEL_CRITICAL = 10;
const FUEL_LEVEL_ALARM = 11;
const NO_FUEL_DATA = 12;

export const notificationService = {
	FUEL_CONSUMPTION_SENSOR_VERIFICATION,
	FUEL_LEVEL_SENSOR_VERIFICATION,
	MAX_FUEL_HEIGHT,
	MIN_FUEL_HEIGHT,
	MAX_WATER_HEIGHT,
	MIN_WATER_HEIGHT,
	FUEL_LEVEL_CRITICAL,
	FUEL_LEVEL_ALARM,
	NO_FUEL_DATA,
	getUserNotifications,
	deleteUserNotifications
};

async function getUserNotifications(lastId) {
	const options = [
        {
            name: "lastId",
            value: lastId
        }
    ];

	const userNotifications = await apiService.get('notification/getUserNotifications', options);
	return userNotifications;
}

async function deleteUserNotifications(userNotificationsConfirm) {
	const countDeletedRows = await apiService.post('notification/deleteUserNotifications', userNotificationsConfirm);
	return countDeletedRows;
}